import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import MasksList from "../Configurations/maskManagement/masks-list";
import UserManagement from "../Configurations/userManagement";
import AddParentUser from "../Configurations/userManagement/parentUser/createParentUser/user-operator-configuration";
import AddEditRewardRateCard from "../Configurations/rate-card/data-rate-card/add-edit-reward-rate-card";
import CreateParentUser from "../Configurations/userManagement/parentUser/createParentUser";
import ViewUser from "../Configurations/userManagement/parentUser/view-user";
import DataFinancialReportChannelWise from "../Reoprts/data-financial-report-channel-wise";

const AddEditRateCard = Loadable(lazy(() => import("../Configurations/rate-card/sms-rate-card/add-edit-sms-rate-card")));
const ManageMaskList = Loadable(lazy(() => import("../Mask")));
const ViewContact = Loadable(lazy(() => import("../ContactList/contact-view/view-contact")));
const ApproveUserList = Loadable(lazy(() => import("../Users/approve-owner/approve-user-list")));
const AllMasksList = Loadable(lazy(() => import("../Mask/mask-list/all-masks-list")));
const ContactList = Loadable(lazy(() => import("../ContactList/contact-list")));
// const FinancialReport = Loadable(lazy(() => import('../Reoprts/financial-report')));
const ManageChildUserList = Loadable(lazy(() => import("../child-user-managent")));
const Dashboard = Loadable(lazy(() => import("../Dashboard/index")));
const CampaignCreation = Loadable(lazy(() => import("../Campaigns/campaign-create/campaign-create")));
const BlackList = Loadable(lazy(() => import("../BlackList")));
const ManageCampaignsUses = Loadable(lazy(() => import("../Campaigns/campaign-uses/campaign-uses")));
const CampaignView = Loadable(lazy(() => import("../Campaigns/campaign-uses/view-uses/campaign-uses-view")));
// const MasksList = Loadable(lazy(() => import("../Mask/masks-list")));
const OwnerList = Loadable(lazy(() => import("../Users/user-list")));
const OwnerView = Loadable(lazy(() => import("../Users/view-user")));
const ChildUserList = Loadable(lazy(() => import("../Configurations/userManagement/childUser/child-user-list")));
const ChannelList = Loadable(lazy(() => import("../Configurations/Channel/channel-list")));
const RateCardList = Loadable(lazy(() => import("../Configurations/rate-card/index")));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const ManageContactList = Loadable(lazy(() => import("../ContactList")));
const TaxManagement = Loadable(lazy(() => import("../Configurations/tax-management/tax-management")));
const CampaignListReport = Loadable(lazy(() => import("../Reoprts/campaign-list-report")));
const ApprovePendingChildUserList = Loadable(lazy(() => import("../Configurations/userManagement/childUser/approve-child-user-list")));
const AllContactList = Loadable(lazy(() => import("../ContactList/all-contact-list")));
const FinancialReportChannelWise = Loadable(lazy(() => import("../Reoprts/financial-report-channel-wise")));

function AdminAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "campaign",
          children: [
            {
              path: "creation",
              element: <CampaignCreation role={role} />,
            },
            {
              path: "list",
              element: <ManageCampaignsUses />,
            },
            {
              path: "view/:type/:id",
              element: <CampaignView />,
            },
          ],
        },
        {
          path: "contact",
          children: [
            {
              path: "create",
              element: <ManageContactList role={role} />,
            },
            {
              path: "list/:id",
              element: <ContactList role={role} />,
            },
            {
              path: "view/:id",
              element: <ViewContact role={role} />,
            },
            {
              path: "list",
              element: <AllContactList role={role} />,
            },
          ],
        },
        {
          path: "mask",
          children: [
            {
              path: "create",
              element: <ManageMaskList role={role} />,
            },
            {
              path: "create/:id",
              element: <MasksList role={role} />,
            },
            {
              path: "list",
              element: <AllMasksList role={role} />,
            },
          ],
        },
        {
          path: "black-list",
          element: <BlackList role={role} />,
        },
        {
          path: "user",
          children: [
            {
              path: "approve",
              element: <ApproveUserList />,
            },
            {
              path: "list",
              element: <OwnerList role={role} />,
            },
            {
              path: "view/:id",
              element: <OwnerView />,
            },
          ],
        },
        {
          path: "child",
          children: [
            {
              path: "list",
              element: <ManageChildUserList role={role} />,
            },
            {
              path: "list/:id",
              element: <ChildUserList role={role} />,
            },
            {
              path: "approve",
              element: <ApprovePendingChildUserList />,
            },
            // {
            //     path: 'approve/:id',
            //     element: <ApprovePendingChildUserList />
            // },
          ],
        },
        {
          path: "config",
          children: [
            {
              path: "mask",
              element: <MasksList role={role} />,
            },
            {
              path: "channel",
              element: <ChannelList />,
            },
            {
              path: "rate-card",
              element: <RateCardList />,
            },
            {
              path: "rate-card/sms/:id",
              element: <AddEditRateCard />,
            },
            {
              path: "rate-card/reward/:id",
              element: <AddEditRewardRateCard />,
            },
            {
              path: "tax-management",
              element: <TaxManagement />,
            },
            {
              path: "users",
              children: [
                {
                  path: "",
                  element: <UserManagement role={role} />,
                },
                {
                  path: "create",
                  element: <CreateParentUser />,
                },
                {
                  path: ":id",
                  element: <ViewUser />,
                },
              ],
            },
          ],
        },
        {
          path: "reports",
          children: [
            {
              path: "campaign-list",
              element: <CampaignListReport />,
            },
            {
              path: "financial-report",
              element: <FinancialReportChannelWise />,
            },
            {
              path: "reward-financial-report",
              element: <DataFinancialReportChannelWise />,
            },
          ],
        },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default AdminAuthorizedRoutes;
